import { render, staticRenderFns } from "./VEmployerCompliance.vue?vue&type=template&id=10f01b20&scoped=true&lang=pug"
import script from "./VEmployerCompliance.vue?vue&type=script&lang=ts"
export * from "./VEmployerCompliance.vue?vue&type=script&lang=ts"
import style0 from "./VEmployerCompliance.vue?vue&type=style&index=0&id=10f01b20&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f01b20",
  null
  
)

/* custom blocks */
import block0 from "./EmployerCompliance.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fpages%2FLayout%2Fviews%2FEmployer%2Fviews%2FCompliance%2FVEmployerCompliance.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports